<template>
  <div id="app">



    <div v-if="!loggedIn" class="container-fluid">      
      <Login v-if="!loggedIn" @login="handleLogin" />    
    </div>
    <div v-if="loggedIn">

      
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
          <div class="container-fluid">
              <a class="navbar-brand" href="#" @click="viewMode = 'solarLocations'">Solar Share</a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span class="navbar-toggler-icon"></span></button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                  <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                      <li class="nav-item"><a class="nav-link" href="#" @click="viewMode = 'addLocation'">Add Location</a></li>
                      <li class="nav-item"><a class="nav-link" href="#" @click="viewMode = 'myLocations'">My Locations</a></li>
                      <li class="nav-item"><a class="nav-link" href="#" @click="handleLogout()">Logout</a></li>                        
                  </ul>
              </div>
          </div>
      </nav>      

      <div class="container-fluid">
        <vue3-confirm-dialog/>
        <LoadingModal />
        <SolarLocations v-if="viewMode == 'solarLocations'"   />
        <AddLocation v-if="viewMode == 'addLocation'" @locationAdded="handleLocationAdded" />
        <MyLocations v-if="viewMode == 'myLocations'" @closeMyLocations="showSolarLocations" />
      </div>
    </div>

<!--
        <v-toolbar title="Solar Share">          
            <v-btn @click="viewMode = 'addLocation'" v-if="viewMode != 'addLocation'">Add Location</v-btn>
            <v-btn @click="viewMode = 'myLocations'" v-if="viewMode != 'myLocations'">My Locations</v-btn>
            <v-btn @click="handleLogout()">Logout</v-btn>                      
        </v-toolbar>
    -->
  </div>
</template>

<script>

import Login from './components/Login.vue';
import LoadingModal from './components/LoadingModal.vue';
import pb from './api';
import SolarLocations from './components/SolarLocations.vue'
import AddLocation from './components/AddLocation.vue'
import MyLocations from './components/MyLocations.vue';

export default {
  name: 'App',
  components: {
    Login,
    //Welcome,
    LoadingModal,
    SolarLocations,
    AddLocation,
    MyLocations
  },
  data() {
    return {
      loggedIn: pb.authStore.isValid,
      viewMode: 'solarLocations'
    };
  },
  async mounted() {
    //this.getLocations();
  },
  methods: {
    handleLogin() {
      this.loggedIn = true;
    },
    handleLogout() {
      pb.authStore.clear();
      this.loggedIn = false;
    },
    handleLocationAdded() {
      this.showSolarLocations();
    },
    showSolarLocations() {
      this.viewMode = 'solarLocations';
    },
    async test() {
      try {
        //let result = await pb.send("/dailyValues?solarIds=K9y33740451,MV9k5449920&date=2025-03-03");
        let result = await pb.send("/dailyValues?solarIds=MV9k5449920&date=2025-03-03");
        console.log(result);
      }
      catch(e) {
        alert(e);
      }
    }
  }
};
</script>

<style>
.container {  
  margin-top: 20px;  
}
</style>